//imports for the validators to be used- these also need to be added to the validators list below
import buildSymptomScores from '../buildSymptomScores.js'
import validatorIndex from '../validators/validatorIndex.js'
import sexExclude from '../validators/sexExclude.js'
import hospitalClinics from '../clinic questions/hospitalclinics.js'
import * as Yup from 'yup'

const reportUtils=
{
validators:[],// list of validators to use]
twrBoost:30,  //amount to elevate path qualifying for 2wr clinic in display
noMessageDrop:30, //amount to downgrade paths with no 2wr message in display


getAge(dob)//calculates age from date of birth- not used in current version since form changed to use age
{
    const dateToday= Date.now()
    const dateOfBirth=new Date(dob)
    const age=(dateToday-dateOfBirth.getTime())/31557600000
    return age
},

orderPathways(formData)
{
    let symptomScores=buildSymptomScores(validatorIndex);
    formData.scoredPathsToUse={};
    formData.pathsToUse.forEach((path)=>
        {
        let score=0
    let pathSymptoms=validatorIndex[path]["symptoms"]
       formData.symptomList.forEach(symptom =>
        {
            if (pathSymptoms.includes(symptom))
                {
                score += symptomScores[symptom]
                }
            }
        )
                // boosts priority of path if two week rule valid    
            if (formData.twrValid[path] || path==="retinoblastoma")// also boosts retinoblatoma due to possible need for emergency referral.
                {
               score += this.twrBoost
                }
                //drops priority of path if not for 2wr clinic and no 2wr message
            else if(formData.message[path]==="")
                {
               score-= this.noMessageDrop
                }
            formData.scoredPathsToUse[path]=score
        })
            
    var paths=Object.entries(formData.scoredPathsToUse)
    paths.sort((a, b) => b[1] - a[1])   
    return paths
},

ValidateTwr(formData)// root method for validation- 
{
    //formData.age=this.getAge(formData.dob);  //taken out of use when incput conveted to age(can be restored in app taking dob)
    formData.age=parseInt(formData.age)
    formData.twrValid={}
    formData.message={}
    formData.investigations=[]

    //this.logAvailableClinics(validatorIndex) //uncomment to log available clincs to console(development use)
    this.findValidators(formData)
    this.validators.forEach((funct)=>{funct(formData)})
    let paths=this.orderPathways(formData)
    formData.sortedPaths=paths
    formData.pathsToUse.forEach((validPath)=>
    {
    if (formData["twrValid"][validPath])
        {
        formData.investigations.push(...validatorIndex[validPath]["requirements"])
        }
    })

    return formData
},

findValidators(formData)
    {
    this.validators=[]
    formData.pathsToUse=[]
     for (let pathway in validatorIndex)
        {
         if (!sexExclude[formData.sex].includes(pathway) && (formData.age <= 15 || !sexExclude.notChild.includes(pathway)))
         // excludes pathways not relevant for sex or age.
            {
            formData.symptomList.some(symptom=>{
            if( validatorIndex[pathway]["symptoms"].includes(symptom))
                {
                this.validators.push(validatorIndex[pathway]["validator"])
                formData.pathsToUse.push(pathway)
                formData.twrValid[pathway]=false
                formData.message[pathway]=""
                return true
                }
            
            return false
    }
    )}}
        },

    logAvailableClinics(validatorIndex)
    //function to search validatorIndex for a current list of available RDC and non RDC clincs at each site - does not run unless call in validatetwr is uncommented- DEV use only
    {
    let clinics = new Set()
    for (let path in validatorIndex)
    {
        clinics.add(...validatorIndex[path]["specialty"])
        console.log(clinics)
    } 
    },

    rdcClinicsAvailable(){
    let allRdcClinics = []
    let paths = []
    paths.push(...Object.keys(validatorIndex))
    paths.forEach((path)=>{let newEntry=validatorIndex[path]["displayAs"]
    allRdcClinics.push(newEntry)
    })
    return allRdcClinics
    }, 
    
    localHospitals(){
    let hospitals=[]
    hospitals.push(...Object.keys(hospitalClinics))
    hospitals.push("Other")
    return hospitals
    },

getPathLabel(readablePath){
for (let cancerType in validatorIndex)
    {
    if (validatorIndex[cancerType]["displayAs"]=== readablePath)
        {
        return validatorIndex[cancerType].path
        }
    }
},

buildValidationsSchema(questionList)
{
let validation = {}
questionList.forEach((question)=>
    {
    if (question.hasOwnProperty("required")  && question.required)
        {
        let label = question["label"]
        let control=question["controlType"]
        let labelNoWhitespace= label.replaceAll(" ","_")
        if (control === 'checkbox group extra wide')
            {
            validation[labelNoWhitespace]= Yup.array().required( "Any entry is required here")
            }
        else
            {
            validation[labelNoWhitespace]= Yup.string().required("Any entry is required here")
            }
    }})
return validation

}



}




export default reportUtils